import React, { useState, useEffect, useRef } from 'react';
import { outlineTexts } from '../contexts/LangMOB';
import growrevenueImg from '../assets/images/mobileum/growrevenue.png';
import reducecostImg from '../assets/images/mobileum/reducecost.png';
import mitigateriskImg from '../assets/images/mobileum/mitigaterisk.png';
import riskImg from '../assets/images/mobileum/risk.png';
import customerImg from '../assets/images/mobileum/customer.png';
import testingImg from '../assets/images/mobileum/testing.png';
import networkImg from '../assets/images/mobileum/network.png';
import dataImg from '../assets/images/mobileum/data.png';

function ProductMOBOutline({ lang = 'ko', isMobile = false }) {
  const [solvingVisible, setSolvingVisible] = useState(false);
  const solvingRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSolvingVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (solvingRef.current) {
      observer.observe(solvingRef.current);
    }

    return () => {
      if (solvingRef.current) {
        observer.unobserve(solvingRef.current);
      }
    };
  }, []);
  const resultContainers = [
    { key: 'growrevenue', title: outlineTexts.result.container.growrevenue.title, desc: outlineTexts.result.container.growrevenue.desc, img: growrevenueImg },
    { key: 'reducecost', title: outlineTexts.result.container.reducecost.title, desc: outlineTexts.result.container.reducecost.desc, img: reducecostImg },
    { key: 'mitigaterisk', title: outlineTexts.result.container.mitigaterisk.title, desc: outlineTexts.result.container.mitigaterisk.desc, img: mitigateriskImg },
  ];

  const solvingContainers = [
    { key: 'roaming', title: outlineTexts.solving.container.roaming.title, desc: outlineTexts.solving.container.roaming.desc, result: outlineTexts.solving.container.roaming.result, resultImg: networkImg },
    { key: 'revenue', title: outlineTexts.solving.container.revenue.title, desc: outlineTexts.solving.container.revenue.desc, result: outlineTexts.solving.container.revenue.result, resultImg: riskImg },
    { key: 'customer', title: outlineTexts.solving.container.customer.title, desc: outlineTexts.solving.container.customer.desc, result: outlineTexts.solving.container.customer.result, resultImg: customerImg },
    { key: 'esim', title: outlineTexts.solving.container.esim.title, desc: outlineTexts.solving.container.esim.desc, result: outlineTexts.solving.container.esim.result, resultImg: testingImg },
    { key: 'iot', title: outlineTexts.solving.container.iot.title, desc: outlineTexts.solving.container.iot.desc, result: outlineTexts.solving.container.iot.result, resultImg: networkImg },
    { key: 'security', title: outlineTexts.solving.container.security.title, desc: outlineTexts.solving.container.security.desc, result: outlineTexts.solving.container.security.result, resultImg: dataImg },
  ];

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100vw',
        background: 'rgba(255, 255, 255, 0.85)',
        // background: '#29225C',
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '20px 16px' : '32px 40px',
        boxSizing: 'border-box',
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.5rem' : '2rem',
        fontWeight: 700,
        color: '#09225C',
        marginBottom: isMobile ? 12 : 24,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center',
        width: '100%'
      }}>
        {outlineTexts.title[lang]}
      </span>

      {/* Result Section */}
      <div style={{
        marginTop: isMobile ? '20px' : '40px',
      }}>
        <span style={{
          fontSize: isMobile ? '1.3rem' : '1.8rem',
          fontWeight: 700,
          color: '#09225C',
          marginBottom: isMobile ? 16 : 28,
          display: 'block',
          lineHeight: 1.4,
          textAlign: 'center',
          width: '100%'
        }}>
          {outlineTexts.result.title[lang]}
        </span>

        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '16px' : '24px',
            width: '100%',
            justifyContent: 'center',
            marginTop: isMobile ? '16px' : '24px',
          }}
        >
          {resultContainers.map((item) => (
            <div
              key={item.key}
              style={{
                background: '#2C3E50',
                borderRadius: 10,
                padding: isMobile ? '16px 12px' : '24px 20px',
                minWidth: isMobile ? '100%' : '280px',
                maxWidth: isMobile ? '100%' : '380px',
                flex: isMobile ? '1 1 100%' : '1 1 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                textAlign: 'left'
              }}
            >
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                marginBottom: '12px',
                gap: isMobile ? '10px' : '16px',
                width: '100%'
              }}>
                <img
                  src={item.img}
                  alt={item.key}
                  style={{
                    width: isMobile ? '48px' : '60px',
                    height: isMobile ? '48px' : '60px',
                    objectFit: 'contain'
                  }}
                />
                <div style={{
                  fontWeight: 700,
                  fontSize: isMobile ? '1.1rem' : '1.4rem',
                  color: '#fff',
                  lineHeight: 1.3,
                  textAlign: 'left'
                }}>
                  {item.title[lang]}
                </div>
              </div>
              <div style={{
                fontWeight: 400,
                fontSize: isMobile ? '0.85rem' : '1rem',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: 1.5,
                textAlign: 'left',
                width: '100%'
              }}>
                {item.desc[lang]}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Solving Section */}
      <div
        ref={solvingRef}
        style={{
          marginTop: isMobile ? '30px' : '50px',
        }}>
        <span style={{
          fontSize: isMobile ? '1.3rem' : '1.8rem',
          fontWeight: 700,
          color: '#09225C',
          marginBottom: isMobile ? 16 : 28,
          display: 'block',
          lineHeight: 1.4,
          textAlign: 'center',
          width: '100%'
        }}>
          {outlineTexts.solving.title[lang]}
        </span>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: isMobile ? '16px' : '24px',
            width: '100%',
            marginTop: isMobile ? '16px' : '24px',
          }}
        >
          {/* 첫 번째 줄: 3개 */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '16px' : '24px',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'stretch',
            }}
          >
            {solvingContainers.slice(0, 3).map((item, idx) => (
              <div
                key={item.key}
                style={{
                  background: '#fff',
                  borderRadius: 10,
                  padding: isMobile ? '16px 12px' : '24px 20px',
                  minWidth: isMobile ? '100%' : '280px',
                  maxWidth: isMobile ? '100%' : '380px',
                  flex: isMobile ? '1 1 100%' : '1 1 0',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  textAlign: 'left',
                  transition: 'all 0.7s cubic-bezier(0.23, 1, 0.32, 1)',
                  opacity: solvingVisible ? 1 : 0,
                  transform: solvingVisible ? 'translateY(0)' : 'translateY(40px)',
                  transitionDelay: solvingVisible ? `${idx * 0.12}s` : '0s'
                }}
              >
                <div style={{
                  fontWeight: 700,
                  fontSize: isMobile ? '1.1rem' : '1.4rem',
                  color: '#09225C',
                  marginBottom: '12px',
                  lineHeight: 1.3,
                  textAlign: 'left'
                }}>
                  {item.title[lang]}
                </div>
                <div style={{
                  fontWeight: 400,
                  fontSize: isMobile ? '0.85rem' : '1rem',
                  color: '#09225C',
                  lineHeight: 1.5,
                  opacity: 0.9,
                  textAlign: 'left'
                }}>
                  {item.desc[lang]}
                </div>
                {/* Result Section */}
                <div style={{
                  marginTop: 'auto',
                  paddingTop: '16px',
                  width: '100%',
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{
                    background: 'transparent',
                    borderTop: '1px solid rgba(9, 34, 92, 0.2)',
                    borderRadius: 0,
                    padding: isMobile ? '12px 10px' : '16px 14px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    position: 'relative',
                    overflow: 'hidden'
                  }}>
                    <img
                      src={item.resultImg}
                      alt=""
                      style={{
                        position: 'absolute',
                        right: isMobile ? '-10px' : '-5px',
                        bottom: isMobile ? '-10px' : '-5px',
                        width: isMobile ? '80px' : '100px',
                        height: isMobile ? '80px' : '100px',
                        objectFit: 'contain',
                        opacity: 0.15,
                        pointerEvents: 'none'
                      }}
                    />
                    <div style={{
                      fontWeight: 700,
                      fontSize: isMobile ? '1rem' : '1.2rem',
                      color: '#2C3E50',
                      marginBottom: '6px',
                      lineHeight: 1.3,
                      position: 'relative',
                      zIndex: 1
                    }}>
                      {item.result.title[lang]}
                    </div>
                    <div style={{
                      fontWeight: 600,
                      fontSize: isMobile ? '0.8rem' : '0.9rem',
                      color: '#09225C',
                      marginBottom: '8px',
                      lineHeight: 1.4,
                      position: 'relative',
                      zIndex: 1
                    }}>
                      {item.result.titlecomment[lang]}
                    </div>
                    <div style={{
                      fontWeight: 400,
                      fontSize: isMobile ? '0.75rem' : '0.85rem',
                      color: '#555',
                      lineHeight: 1.5,
                      position: 'relative',
                      zIndex: 1
                    }}>
                      {item.result.comment[lang]}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* 두 번째 줄: 3개 */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '16px' : '24px',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'stretch',
            }}
          >
            {solvingContainers.slice(3, 6).map((item, idx) => (
              <div
                key={item.key}
                style={{
                  background: '#fff',
                  borderRadius: 10,
                  padding: isMobile ? '16px 12px' : '24px 20px',
                  minWidth: isMobile ? '100%' : '280px',
                  maxWidth: isMobile ? '100%' : '380px',
                  flex: isMobile ? '1 1 100%' : '1 1 0',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  textAlign: 'left',
                  transition: 'all 0.7s cubic-bezier(0.23, 1, 0.32, 1)',
                  opacity: solvingVisible ? 1 : 0,
                  transform: solvingVisible ? 'translateY(0)' : 'translateY(40px)',
                  transitionDelay: solvingVisible ? `${(idx + 3) * 0.12}s` : '0s'
                }}
              >
                <div style={{
                  fontWeight: 700,
                  fontSize: isMobile ? '1.1rem' : '1.4rem',
                  color: '#09225C',
                  marginBottom: '12px',
                  lineHeight: 1.3,
                  textAlign: 'left'
                }}>
                  {item.title[lang]}
                </div>
                <div style={{
                  fontWeight: 400,
                  fontSize: isMobile ? '0.85rem' : '1rem',
                  color: '#09225C',
                  lineHeight: 1.5,
                  opacity: 0.9,
                  textAlign: 'left'
                }}>
                  {item.desc[lang]}
                </div>
                {/* Result Section */}
                <div style={{
                  marginTop: 'auto',
                  paddingTop: '16px',
                  width: '100%',
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{
                    background: 'transparent',
                    borderTop: '1px solid rgba(9, 34, 92, 0.2)',
                    borderRadius: 0,
                    padding: isMobile ? '12px 10px' : '16px 14px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    position: 'relative',
                    overflow: 'hidden'
                  }}>
                    <img
                      src={item.resultImg}
                      alt=""
                      style={{
                        position: 'absolute',
                        right: isMobile ? '-10px' : '-5px',
                        bottom: isMobile ? '-10px' : '-5px',
                        width: isMobile ? '80px' : '100px',
                        height: isMobile ? '80px' : '100px',
                        objectFit: 'contain',
                        opacity: 0.15,
                        pointerEvents: 'none'
                      }}
                    />
                    <div style={{
                      fontWeight: 700,
                      fontSize: isMobile ? '1rem' : '1.2rem',
                      color: '#2C3E50',
                      marginBottom: '6px',
                      lineHeight: 1.3,
                      position: 'relative',
                      zIndex: 1
                    }}>
                      {item.result.title[lang]}
                    </div>
                    <div style={{
                      fontWeight: 600,
                      fontSize: isMobile ? '0.8rem' : '0.9rem',
                      color: '#09225C',
                      marginBottom: '8px',
                      lineHeight: 1.4,
                      position: 'relative',
                      zIndex: 1
                    }}>
                      {item.result.titlecomment[lang]}
                    </div>
                    <div style={{
                      fontWeight: 400,
                      fontSize: isMobile ? '0.75rem' : '0.85rem',
                      color: '#555',
                      lineHeight: 1.5,
                      position: 'relative',
                      zIndex: 1
                    }}>
                      {item.result.comment[lang]}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductMOBOutline;
